// * Bootstrap libraries
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// * Any other global site-wide JavaScript should be placed below.
import './mega-menu'

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);
window.Swiper = Swiper;

// COOKIEBOT RENEW
document.addEventListener("click", (e) => {
  const renewBtn = e.target.closest('.cookieconsent-optout-marketing__cookiebot-renew');
  if (renewBtn) {
    e.preventDefault();
    if (window.Cookiebot && typeof Cookiebot.renew === "function") {
      Cookiebot.renew();
    } else {
      console.warn("Cookiebot.renew() n'est pas disponible.");
    }
  }
});

// COOKIEBOT FOOTER
document.addEventListener("DOMContentLoaded", () => {
  const lastFooterItem = document.querySelector("footer.page__footer ul.nav.navbar-nav li:last-child a");
  if (!lastFooterItem) return;

  lastFooterItem.addEventListener("click", (e) => {
    e.preventDefault();
    if (window.Cookiebot && typeof Cookiebot.renew === "function") {
      Cookiebot.renew();
    } else {
      console.warn("Cookiebot.renew() n'est pas disponible.");
    }
  });
});

// LEGAL ACCORDION
document.addEventListener("DOMContentLoaded", () => {
  const accordion = document.querySelector(".legal-accordion");
  if (!accordion) return;

  // Cache toutes les réponses
  document.querySelectorAll(".a").forEach(a => {
    a.style.display = "none";
  });

  // Gestion du clic sur une question
  accordion.querySelectorAll(".q").forEach(q => {
    q.addEventListener("click", () => {
      const answer = q.nextElementSibling;

      // Toggle l'élément cliqué
      if (answer.style.display === "none" || answer.style.display === "") {
        slideDown(answer);
      } else {
        slideUp(answer);
      }

      // Ferme les autres réponses
      document.querySelectorAll(".a").forEach(a => {
        if (a !== answer) slideUp(a);
      });
    });
  });

  // Si un hash est présent dans l’URL
  const hash = window.location.hash;
  if (hash) {
    const requestedPanel = document.querySelector(hash);
    if (requestedPanel && requestedPanel.classList.contains("q")) {
      // Cache toutes les réponses
      document.querySelectorAll(".a").forEach(a => (a.style.display = "none"));

      // Affiche celle liée au hash
      const answer = requestedPanel.nextElementSibling;
      if (answer && answer.classList.contains("a")) {
        answer.style.display = "block";
      }

      window.addEventListener("load", () => {
        window.scrollTo({
          top: requestedPanel.getBoundingClientRect().top + window.scrollY - 50,
          behavior: "smooth"
        });
      });
    }
  }

  // Fonctions pour simuler slideUp / slideDown de jQuery
  function slideUp(element) {
    element.style.transition = "height 0.3s ease";
    element.style.overflow = "hidden";
    element.style.height = element.scrollHeight + "px";
    requestAnimationFrame(() => {
      element.style.height = "0px";
    });
    element.addEventListener("transitionend", () => {
      element.style.display = "none";
      element.style.height = "";
      element.style.transition = "";
      element.style.overflow = "";
    }, { once: true });
  }

  function slideDown(element) {
    element.style.display = "block";
    const height = element.scrollHeight + "px";
    element.style.height = "0px";
    element.style.overflow = "hidden";
    element.style.transition = "height 0.3s ease";
    requestAnimationFrame(() => {
      element.style.height = height;
    });
    element.addEventListener("transitionend", () => {
      element.style.height = "";
      element.style.transition = "";
      element.style.overflow = "";
    }, { once: true });
  }
});
